module.exports = __webpack_public_path__ + "static/img/gregorys_logo.7766f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gregorys_logo.png
// module id = KmJa
// module chunks = 47